// Phân loại lỗi POST /auth/owner-login → câu hiển thị cho màn Login (Round 17).
//
// Vì sao tách riêng: trước đây MỌI lỗi (mất mạng, IIS trả trang HTML lúc app pool
// đang khởi động, 5xx, CORS...) đều rơi về "Tên đăng nhập hoặc mật khẩu không đúng"
// → khách tưởng gõ sai mật khẩu và thử lại mãi. Chỉ 401 mới thật sự là sai tài khoản.
// Hàm THUẦN (không import gì) để unit test được mà không cần dựng React/Redux.

// Status dạng CHUỖI của RTK Query: không có HTTP status đọc được (mất mạng, DNS, CORS
// chặn, hết giờ chờ) hoặc body không phải JSON (IIS trả HTML khi app pool khởi động).
const UNREACHABLE_STATUSES = ['FETCH_ERROR', 'TIMEOUT_ERROR', 'PARSING_ERROR'];

// Trạng thái riêng cho nhánh 200 nhưng thiếu token (không phải lỗi HTTP).
export const LOGIN_STATUS_NO_TOKEN = 'no-token';

// Message backend (ApiResponse { message }) — phòng thủ casing như pickField.
export const getLoginErrorMessage = (error) => {
  const data = error?.data;
  if (!data || typeof data !== 'object') {
    return '';
  }
  const message = data.message ?? data.Message;
  return typeof message === 'string' ? message.trim() : '';
};

const isServerUnreachable = (status) =>
  status === undefined ||
  status === null ||
  status === 0 ||
  UNREACHABLE_STATUSES.includes(status) ||
  (typeof status === 'number' && status >= 500);

export const resolveLoginError = (error, t) => {
  const status = error?.status;

  if (status === 401) {
    // Sai tài khoản/mật khẩu hoặc bị khoá 15' — message backend chứa giờ mở khoá,
    // hiển thị NGUYÊN VĂN.
    return getLoginErrorMessage(error) || t('page.login.fail');
  }

  if (isServerUnreachable(status)) {
    return t('page.login.serverUnreachable');
  }

  if (status === 403) {
    return t('page.login.forbidden');
  }

  if (status === 429) {
    return t('page.login.tooMany');
  }

  // 400, 404, 415, 'CUSTOM_ERROR', 'no-token'... → báo kèm mã để DEV tra.
  return t('page.login.unexpected', { status: String(status) });
};
